import { memo } from 'react';

type Props = {
    value: string;
}

export const ValveFilterTooltip = memo(({ value }: Props) => {
    const content = value.split(',')
        .map((name) => (
            <div key={`valves-tooltip_${name}`} className="vss-valves-tooltip-value__row">
                <p className="vss-valves-tooltip-value__label">
                    {name}
                </p>
            </div>
        ));
    return (
        <div className="vss-valves-tooltip-value">
            {content}
        </div>
    );
});
